import { ReactComponent as UploadFileIcon } from '../../../../assets/images/icon-upload.svg';

const NoAttachments = () => (
  <div className="mt-3 d-flex justify-content-center align-items-center flex-column">
    <UploadFileIcon />
    <h6 className="mt-3">No disponés de ningún archivo adjunto</h6>
  </div>
);

export default NoAttachments;
